import { useLocation, Link } from "react-router-dom";
import { useTheme, Box } from "@mui/material";
import LogoSection from "../LogoSection";
import ProfileMenu from "./ProfileMenu";
import ToggleColorMode from "components/ToggleColorMode";

const Header = () => {
  const theme = useTheme();
  const location = useLocation();

  // Function to check if a link is active
  const isActiveLink = (path) => {
    return location.pathname === path;
  };

  // Common link styles with active state
  const getLinkStyles = (isActive) => ({
    color: isActive ? theme.palette.text.secondary : theme.palette.text.primary,
    textDecoration: "none",
    fontSize: "0.875rem",
    fontWeight: isActive ? 700 : 500,
    padding: "8px 12px",
    borderRadius: "16px",
    backgroundColor: isActive
      ? theme.palette.mode === "dark"
        ? theme.palette.action.hover
        : "#f5f5f5"
      : "transparent",
    border: isActive ? `1px solid ${theme.palette.divider}` : "none",
    transition: "background-color 0.2s ease-in-out",
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? theme.palette.action.hover
          : "rgb(240, 240, 240)",
    },
  });

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        height: "100%",
      }}
    >
      {/* Logo Section - Left Aligned */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          minWidth: "228px",
          [theme.breakpoints.down("md")]: {
            minWidth: "auto",
          },
        }}
      >
        <LogoSection />
      </Box>

      {/* Navigation Section - Center Aligned */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexGrow: 1,
        }}
      >
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            gap: 2,
            alignItems: "center",
          }}
        >
          <Link to="/" style={getLinkStyles(isActiveLink("/"))}>
            Users
          </Link>
          <Link to="/connections" style={getLinkStyles(isActiveLink("/connections"))}>
            Connections
          </Link>
          <Link to="/subscriptions" style={getLinkStyles(isActiveLink("/subscriptions"))}>
            Subscriptions
          </Link>
          <Link to="/promo-codes" style={getLinkStyles(isActiveLink("/promo-codes"))}>
            Promos
          </Link>
          <Link to="/stripe-products" style={getLinkStyles(isActiveLink("/stripe-products"))}>
            Stripe
          </Link>
          <Link to="/beehiiv-subscribers" style={getLinkStyles(isActiveLink("/beehiiv-subscribers"))}>
            Beehiiv
          </Link>
          <Link to="/docs" style={getLinkStyles(isActiveLink("/docs"))}>
            Docs
          </Link>
          <Link to="/env" style={getLinkStyles(isActiveLink("/env"))}>
            Env
          </Link>
        </Box>
      </Box>

      {/* Profile Section - Right Aligned */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          minWidth: "228px",
          gap: 2,
          [theme.breakpoints.down("md")]: {
            minWidth: "auto",
          },
        }}
      >
        <ToggleColorMode />
        <ProfileMenu />
      </Box>
    </Box>
  );
};


export default Header;
